import { types, actions } from './requests'
export const GETLISTINGLIST_TYPES = {
    ...types('GETLISTINGLIST'),
}
export const GETLISTINGLIST_ACTIONS = {
    ...actions('GETLISTINGLIST'),
}